import { createCashPaymentMethod } from "./Cash";
import { createNzBankPaymentMethod } from "./NzBank";
import { createAkahuOneOffPaymentMethod } from "./AkahuOneOff";
import { PaymentMethod, PaymentRegion } from "./paymentMethod";

/**
 * Registry of available payment methods
 */
export const paymentMethods: Record<string, PaymentMethod> = {
  "akahu-one-off": createAkahuOneOffPaymentMethod(),
  "nz-bank": createNzBankPaymentMethod(),
  cash: createCashPaymentMethod(),
};

/**
 * Get a payment method by ID
 * @param id The payment method ID
 * @returns The payment method or undefined if not found
 */
export const getPaymentMethod = (id: string): PaymentMethod | undefined => {
  return paymentMethods[id];
};

/**
 * Get all payment methods available in a specific region
 * @param region The region to filter by
 * @returns Array of payment methods available in the region
 */
export const getPaymentMethodsByRegion = (region: PaymentRegion): PaymentMethod[] => {
  return Object.values(paymentMethods).filter(
    (method) => method.isAvailableInRegion(region) || method.isAvailableInRegion("global"),
  );
};

export { PaymentMethod } from "./paymentMethod";
export type { PaymentRegion } from "./paymentMethod";
export * from "../akahu/copy";
export * from "../akahu/supportedBanks";
